// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg width="16" height="16" version="1.1" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 .4C11.4.4.4 11.4.4 25c0 13.6 11 24.6 24.6 24.6 13.6 0 24.6-11 24.6-24.6C49.6 11.4 38.6.4 25 .4zm0 9c1.6 0 3 1.2 3 3s-1.4 3-3 3c-1.8 0-3-1.4-3-3s1.3-3 3-3zM29 24v17h-4V25h-4v-4h8v3z"></path>
    </svg>
`
};

export const IconAlertInfo = () => <span dangerouslySetInnerHTML={icon} />;

export default IconAlertInfo;
